var _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 8V11.3333C3.33333 12.4379 4.22876 13.3333 5.33333 13.3333H10.6667C11.7712 13.3333 12.6667 12.4379 12.6667 11.3333V8",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 3.99935C4 3.26297 4.59695 2.66602 5.33333 2.66602V2.66602C6.80609 2.66602 8 3.85992 8 5.33268V5.33268H5.33333C4.59695 5.33268 4 4.73573 4 3.99935V3.99935Z",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.99935C12 3.26297 11.403 2.66602 10.6667 2.66602V2.66602C9.19391 2.66602 8 3.85992 8 5.33268V5.33268H10.6667C11.403 5.33268 12 4.73573 12 3.99935V3.99935Z",
    stroke: "white",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.66667,
    y: 5.33398,
    width: 10.6667,
    height: 2.66667,
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8V13.3333",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.aead8c8d3dc65012aca72789d14ab631.svg";
export { ForwardRef as ReactComponent };